import fecha from 'fecha';
import { PLATFORM_DATETIME_FORMAT } from './constants';
export var formatDateTimeString = function (dateString, toFormat, fromFormat, i18n) {
  if (toFormat === void 0) {
    toFormat = 'DD/MM/YYYY';
  }
  if (fromFormat === void 0) {
    fromFormat = PLATFORM_DATETIME_FORMAT;
  }
  if (!dateString) {
    return '';
  }
  var parsed = fecha.parse(dateString, fromFormat);
  return parsed ? fecha.format(parsed, toFormat, i18n) : dateString;
};